import { useState } from 'react'

type CarouselGridCount = [number | null, (v: number) => void]

export const useCarouselGridCount = (): CarouselGridCount => {
  const [value, setValue] = useState<number | null>(null)
  return [value, setValue]
}
